import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <g id="Vector">
        <path
          d="M11.8657 22.4149C11.6382 22.7789 11.2392 23 10.81 23C9.6211 23 8.7349 21.9038 8.98401 20.7413L10 16H3.5C2.39543 16 1.5 15.1046 1.5 14V9.94427C1.5 9.32329 1.64458 8.71084 1.92229 8.15542L3.94721 4.10557C4.286 3.428 4.97852 3 5.73607 3H16.5V15L11.8657 22.4149Z"
          fill="#D1D1D1"
        />
        <path
          d="M21 15C21.5523 15 22 14.5523 22 14V4C22 3.44772 21.5523 3 21 3H18V15H21Z"
          fill="#D1D1D1"
        />
      </g>
    </g>
  </svg>
);
export default SVGComponent;
